import request from '@/utils/request'

// 获取角色列表
export function getRoleList(data) {
  return request({
    url: '/admin/setting/webRole/list',
    method: 'post',
    data: data
  })
}
// 更新角色
export function updataRole(data) {
  return request({
    url: '/admin/setting/webRole/edit',
    method: 'post',
    data: data
  })
}
// 新增角色
export function addRole(data) {
  return request({
    url: '/admin/setting/webRole/add',
    method: 'post',
    data: data
  })
}
